import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, Suspense as _Suspense, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "mt-0"
}
const _hoisted_4 = { class: "grid mb-4" }
const _hoisted_5 = { class: "col-12 lg:col-4" }
const _hoisted_6 = {
  key: 0,
  class: "card"
}
const _hoisted_7 = {
  key: 1,
  class: "card"
}
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = {
  key: 2,
  class: "card"
}
const _hoisted_10 = { class: "p-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "p-fluid" }
const _hoisted_13 = { class: "card" }
const _hoisted_14 = { class: "p-fluid" }
const _hoisted_15 = { class: "col-12 lg:col-4" }
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "p-fluid" }
const _hoisted_18 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_19 = {
  key: 0,
  class: "card"
}
const _hoisted_20 = { class: "p-fluid" }
const _hoisted_21 = {
  key: 2,
  class: "card"
}
const _hoisted_22 = { class: "p-fluid" }
const _hoisted_23 = {
  key: 5,
  class: "card"
}
const _hoisted_24 = { class: "p-fluid" }
const _hoisted_25 = { class: "p-fluid" }
const _hoisted_26 = { class: "p-fluid" }
const _hoisted_27 = { class: "p-fluid" }
const _hoisted_28 = {
  key: 6,
  class: "card"
}
const _hoisted_29 = { class: "p-fluid" }
const _hoisted_30 = {
  key: 7,
  class: "card"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h6", null, "Pusher 🔔", -1)
const _hoisted_32 = { class: "p-fluid" }
const _hoisted_33 = { class: "p-fluid" }
const _hoisted_34 = { class: "p-fluid" }
const _hoisted_35 = { class: "p-fluid" }
const _hoisted_36 = {
  key: 8,
  class: "card"
}
const _hoisted_37 = { class: "p-fluid" }
const _hoisted_38 = { class: "p-fluid" }
const _hoisted_39 = {
  key: 9,
  class: "card"
}
const _hoisted_40 = { class: "p-fluid" }
const _hoisted_41 = { class: "p-fluid" }
const _hoisted_42 = { class: "p-fluid" }
const _hoisted_43 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_44 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_45 = { class: "p-fluid" }
const _hoisted_46 = {
  key: 10,
  class: "card"
}
const _hoisted_47 = { class: "p-fluid" }
const _hoisted_48 = { class: "card" }
const _hoisted_49 = { class: "p-fluid" }
const _hoisted_50 = { class: "card" }
const _hoisted_51 = { class: "p-fluid" }
const _hoisted_52 = {
  key: 12,
  class: "card"
}
const _hoisted_53 = { class: "p-fluid" }
const _hoisted_54 = {
  key: 13,
  class: "card"
}
const _hoisted_55 = { class: "p-fluid mb-4" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{endpoint_id}"),
  /*#__PURE__*/_createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{endpoint_uuid}"),
  /*#__PURE__*/_createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{subid}"),
  /*#__PURE__*/_createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{subid_uuid}"),
  /*#__PURE__*/_createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{reason}")
], -1)
const _hoisted_57 = { class: "p-fluid" }
const _hoisted_58 = { class: "col-12 lg:col-4" }
const _hoisted_59 = { class: "card" }
const _hoisted_60 = { class: "p-fluid" }
const _hoisted_61 = {
  key: 0,
  class: "card"
}
const _hoisted_62 = {
  key: 1,
  class: "card"
}
const _hoisted_63 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_64 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_65 = {
  key: 2,
  class: "card"
}
const _hoisted_66 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_EndpointMeta = _resolveComponent("EndpointMeta")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_FieldDropdown = _resolveComponent("FieldDropdown")!
  const _component_FieldNumber = _resolveComponent("FieldNumber")!
  const _component_ShaveRules = _resolveComponent("ShaveRules")!
  const _component_FieldBidCPC = _resolveComponent("FieldBidCPC")!
  const _component_HardcodedBids = _resolveComponent("HardcodedBids")!
  const _component_FieldCheckbox = _resolveComponent("FieldCheckbox")!
  const _component_FieldDate = _resolveComponent("FieldDate")!
  const _component_FieldListBox = _resolveComponent("FieldListBox")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_FieldTextarea = _resolveComponent("FieldTextarea")!
  const _component_Entry = _resolveComponent("Entry")!

  return (_openBlock(), _createBlock(_component_Entry, {
    title: _ctx.$t('endpoint'),
    entry: _ctx.endpoint,
    "entry-fetch-handler": _ctx.fetchEndpoint,
    "entry-store-handler": _ctx.user.isAffiliate() ? null : _ctx.storeEndpoint,
    "entry-errors-map": _ctx.endpointErrorsMap,
    "onUpdate:entry-errors-map": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.endpointErrorsMap) = $event))
  }, {
    "buttons-col-2-prepend": _withCtx(() => [
      (!!_ctx.endpoint.id && _ctx.endpoint.protocol !== _ctx.PROTOCOL_DIRECT_LINK && _ctx.user.isStaff())
        ? (_openBlock(), _createBlock(_component_PrimeVueButton, {
            key: 0,
            class: "p-button-secondary ml-4 mb-0",
            label: _ctx.$t('clone'),
            icon: "pi pi-copy",
            onClick: _ctx.cloneEndpoint
          }, null, 8, ["label", "onClick"]))
        : _createCommentVNode("", true),
      (!!_ctx.endpoint.id && _ctx.user.isStaff())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("a", {
              class: "ml-4",
              href: `/users/${_ctx.endpoint.user_id}`,
              target: "_blank"
            }, [
              _createVNode(_component_PrimeVueButton, {
                class: "p-button-info mb-0",
                label: _ctx.$t('user'),
                icon: "pi pi-user"
              }, null, 8, ["label"])
            ], 8, _hoisted_1),
            (!!_ctx.endpoint.site_id)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "ml-4",
                  href: `/sites/${_ctx.endpoint.site_id}`,
                  target: "_blank"
                }, [
                  _createVNode(_component_PrimeVueButton, {
                    class: "p-button-info mb-0",
                    label: _ctx.$t('site'),
                    icon: "pi pi-desktop"
                  }, null, 8, ["label"])
                ], 8, _hoisted_2))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_ctx.user.isStaff())
        ? (_openBlock(), _createElementBlock("h3", _hoisted_3, "⚙️ " + _toDisplayString(_ctx.$t('common_settings')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (!!_ctx.endpoint.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(), _createBlock(_Suspense, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_EndpointMeta, {
                      endpoint: _ctx.endpoint,
                      "show-compiled-name": true,
                      "show-uuid": true
                    }, null, 8, ["endpoint"])
                  ]),
                  fallback: _withCtx(() => [
                    _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                  ]),
                  _: 1
                }))
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isSuperAdmin())
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_FieldDropdown, {
                    modelValue: _ctx.endpoint.project_id,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.endpoint.project_id) = $event)),
                      _ctx.onProjectChange
                    ],
                    modelModifiers: { number: true },
                    name: "project_id",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('project'),
                    loading: _ctx.projectsLoading,
                    disabled: !!_ctx.endpoint.id,
                    options: _ctx.projects.data,
                    "option-value": "id",
                    "option-label": "name",
                    "option-label-translate": false
                  }, null, 8, ["modelValue", "errors-map", "label", "loading", "disabled", "options", "onUpdate:modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_FieldDropdown, {
                    modelValue: _ctx.endpoint.user_id,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endpoint.user_id) = $event)),
                      _ctx.onUserChange
                    ],
                    modelModifiers: { number: true },
                    name: "user_id",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('user'),
                    loading: _ctx.usersLoading,
                    disabled: !!_ctx.endpoint.id,
                    options: _ctx.users.data,
                    "option-value": "id",
                    "option-label": "compiled_name",
                    "option-label-translate": false,
                    filter: true
                  }, null, 8, ["modelValue", "errors-map", "label", "loading", "disabled", "options", "onUpdate:modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.endpoint.site_id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endpoint.site_id) = $event)),
                modelModifiers: { number: true },
                name: "site_id",
                "errors-map": _ctx.endpointErrorsMap,
                label: _ctx.$t('site'),
                loading: _ctx.sitesLoading,
                disabled: !!_ctx.endpoint.id,
                options: _ctx.sites.data,
                "option-value": "id",
                "option-label": "compiled_name",
                "option-label-translate": false
              }, null, 8, ["modelValue", "errors-map", "label", "loading", "disabled", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.endpoint.traffic_type,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endpoint.traffic_type) = $event)),
                  _ctx.onTrafficTypeChange
                ],
                modelModifiers: { number: true },
                name: "traffic_type",
                "errors-map": _ctx.endpointErrorsMap,
                label: _ctx.$t('type'),
                disabled: !!_ctx.endpoint.id,
                options: _ctx.TRAFFIC_TYPES
              }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options", "onUpdate:modelValue"]),
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.endpoint.traffic_category,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endpoint.traffic_category) = $event)),
                  _ctx.onTrafficCategoryChange
                ],
                modelModifiers: { number: true },
                name: "traffic_category",
                "errors-map": _ctx.endpointErrorsMap,
                label: _ctx.$t('category'),
                disabled: !!_ctx.endpoint.id,
                options: _ctx.TRAFFIC_CATEGORIES
              }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options", "onUpdate:modelValue"]),
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.endpoint.region,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.endpoint.region) = $event)),
                modelModifiers: { number: true },
                name: "region",
                "errors-map": _ctx.endpointErrorsMap,
                label: _ctx.$t('region'),
                disabled: _ctx.user.isAffiliate(),
                options: _ctx.REGIONS
              }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.endpoint.protocol,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.endpoint.protocol) = $event)),
                modelModifiers: { number: true },
                name: "protocol",
                "errors-map": _ctx.endpointErrorsMap,
                label: _ctx.$t('protocol'),
                disabled: _ctx.user.isAffiliate(),
                options: _ctx.protocols
              }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options"])
            ]),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_FieldDropdown, {
                    modelValue: _ctx.endpoint.custom_response_provider,
                    "onUpdate:modelValue": [
                      _cache[7] || (_cache[7] = ($event: any) => ((_ctx.endpoint.custom_response_provider) = $event)),
                      _ctx.onCustomResponseProviderChange
                    ],
                    modelModifiers: { number: true },
                    name: "custom_response_provider",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('custom_response_provider'),
                    "show-clear": true,
                    disabled: _ctx.user.isAffiliate(),
                    options: _ctx.CUSTOM_RESPONSE_PROVIDERS,
                    "option-label": "label",
                    "option-label-translate": false
                  }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options", "onUpdate:modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_FieldDropdown, {
                    modelValue: _ctx.endpoint.bid_subject,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.endpoint.bid_subject) = $event)),
                    modelModifiers: { number: true },
                    name: "bid_subject",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('bid_subject'),
                    options: _ctx.BID_SUBJECTS,
                    "option-label": "label"
                  }, null, 8, ["modelValue", "errors-map", "label", "options"]),
                  _createVNode(_component_FieldDropdown, {
                    modelValue: _ctx.endpoint.bid_type,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.endpoint.bid_type) = $event)),
                    modelModifiers: { number: true },
                    name: "bid_type",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('bid_type'),
                    help: _ctx.$t('bid_type_help'),
                    options: _ctx.BID_TYPES,
                    "option-label": "label",
                    "option-label-translate": false
                  }, null, 8, ["modelValue", "errors-map", "label", "help", "options"]),
                  (_ctx.user.isStaff())
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_FieldNumber, {
                          modelValue: _ctx.endpoint.revshare,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.endpoint.revshare) = $event)),
                          modelModifiers: { number: true },
                          name: "revshare",
                          "errors-map": _ctx.endpointErrorsMap,
                          label: _ctx.$t('revshare'),
                          min: 1,
                          max: 200,
                          step: 5,
                          "show-buttons": "",
                          "button-layout": "horizontal",
                          "increment-button-icon": "pi pi-plus",
                          "decrement-button-icon": "pi pi-minus",
                          suffix: "%"
                        }, null, 8, ["modelValue", "errors-map", "label"]),
                        _createVNode(_component_FieldNumber, {
                          modelValue: _ctx.endpoint.shave,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.endpoint.shave) = $event)),
                          modelModifiers: { number: true },
                          name: "shave",
                          "errors-map": _ctx.endpointErrorsMap,
                          label: _ctx.$t('shave'),
                          min: 0,
                          max: 100,
                          step: 5,
                          "show-buttons": "",
                          "button-layout": "horizontal",
                          "increment-button-icon": "pi pi-plus",
                          "decrement-button-icon": "pi pi-minus",
                          suffix: "%"
                        }, null, 8, ["modelValue", "errors-map", "label"]),
                        _createVNode(_component_FieldNumber, {
                          modelValue: _ctx.endpoint.pay_filtered_click_chance,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.endpoint.pay_filtered_click_chance) = $event)),
                          modelModifiers: { number: true },
                          name: "pay_filtered_click_chance",
                          "errors-map": _ctx.endpointErrorsMap,
                          label: _ctx.$t('pay_filtered_click_chance'),
                          min: 0,
                          max: 100,
                          step: 5,
                          "show-buttons": "",
                          "button-layout": "horizontal",
                          "increment-button-icon": "pi pi-plus",
                          "decrement-button-icon": "pi pi-minus",
                          suffix: "%"
                        }, null, 8, ["modelValue", "errors-map", "label"]),
                        _createVNode(_component_FieldNumber, {
                          modelValue: _ctx.endpoint.min_bid_override,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.endpoint.min_bid_override) = $event)),
                          name: "min_bid_override",
                          "errors-map": _ctx.endpointErrorsMap,
                          label: _ctx.$t('min_bid'),
                          min: 0,
                          "min-fraction-digits": 1,
                          "max-fraction-digits": 8,
                          prefix: "$"
                        }, null, 8, ["modelValue", "errors-map", "label"])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createBlock(_Suspense, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ShaveRules, {
                    class: "mt-4",
                    modelValue: _ctx.endpoint.shave_rules,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.endpoint.shave_rules) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                fallback: _withCtx(() => [
                  _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_FieldBidCPC, {
                    modelValue: _ctx.endpoint.hardcoded_bid,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.endpoint.hardcoded_bid) = $event)),
                    modelModifiers: { number: true },
                    name: "hardcoded_bid",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('fixed_bid'),
                    help: _ctx.$t('fixed_bid_help')
                  }, null, 8, ["modelValue", "errors-map", "label", "help"])
                ])
              ]))
            : _createCommentVNode("", true),
          (!!_ctx.endpoint.id && _ctx.endpoint.protocol === _ctx.PROTOCOL_DIRECT_LINK && _ctx.user.isStaff())
            ? (_openBlock(), _createBlock(_Suspense, { key: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_HardcodedBids, {
                    class: "mt-3",
                    modelValue: _ctx.endpoint.hardcoded_bids,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.endpoint.hardcoded_bids) = $event)),
                    title: _ctx.$t('fixed_bid_by_countries')
                  }, null, 8, ["modelValue", "title"])
                ]),
                fallback: _withCtx(() => [
                  _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createBlock(_Suspense, { key: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ShaveRules, {
                    class: "mt-4",
                    modelValue: _ctx.endpoint.shave_rules,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.endpoint.shave_rules) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                fallback: _withCtx(() => [
                  _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.allow_referrer_mismatch,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.endpoint.allow_referrer_mismatch) = $event)),
                    label: _ctx.$t('allow_referrer_mismatch')
                  }, null, 8, ["modelValue", "label"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.get_ip_and_user_agent_from_headers,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.endpoint.get_ip_and_user_agent_from_headers) = $event)),
                    label: _ctx.$t('get_ip_and_user_agent_from_headers')
                  }, null, 8, ["modelValue", "label"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_FieldDate, {
                    modelValue: _ctx.endpoint.subids_checking_delay_to,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.endpoint.subids_checking_delay_to) = $event)),
                    label: _ctx.$t('subids_checking_delay_to'),
                    "show-time": true
                  }, null, 8, ["modelValue", "label"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.disable_decline_non_effective_subids,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.endpoint.disable_decline_non_effective_subids) = $event)),
                    label: _ctx.$t('disable_decline_non_effective_subids')
                  }, null, 8, ["modelValue", "label"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_FieldDropdown, {
                    modelValue: _ctx.endpoint.max_qps,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.endpoint.max_qps) = $event)),
                    modelModifiers: { number: true },
                    name: "max_qps",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: "QPS",
                    options: _ctx.ENDPOINT_MAX_QPS,
                    "option-label": "label",
                    "option-label-translate": false
                  }, null, 8, ["modelValue", "errors-map", "options"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.endpoint.traffic_type === _ctx.TRAFFIC_TYPE_PUSH && _ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.push_delay_to_first_sending,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.endpoint.push_delay_to_first_sending) = $event)),
                    modelModifiers: { number: true },
                    name: "push_delay_to_first_sending",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('delay_to_first_sending'),
                    min: 0,
                    step: 30,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus",
                    suffix: ` ${_ctx.$t('sec')}`
                  }, null, 8, ["modelValue", "errors-map", "label", "suffix"])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.push_delay_to_sending,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.endpoint.push_delay_to_sending) = $event)),
                    modelModifiers: { number: true },
                    name: "push_delay_to_sending",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('delay_to_sending'),
                    min: 0,
                    step: 30,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus",
                    suffix: ` ${_ctx.$t('sec')}`
                  }, null, 8, ["modelValue", "errors-map", "label", "suffix"])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.push_max_sendings,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.endpoint.push_max_sendings) = $event)),
                    modelModifiers: { number: true },
                    name: "push_max_sendings",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('max_sendings'),
                    min: 0,
                    step: 25,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus"
                  }, null, 8, ["modelValue", "errors-map", "label"])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.push_max_age,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.endpoint.push_max_age) = $event)),
                    modelModifiers: { number: true },
                    name: "push_max_age",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('max_age'),
                    min: 1,
                    step: 1,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus"
                  }, null, 8, ["modelValue", "errors-map", "label"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.endpoint.protocol === _ctx.PROTOCOL_DIRECT_LINK)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("h6", null, _toDisplayString(_ctx.$t('pop_code')), 1),
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.pop_frequency_seconds,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.endpoint.pop_frequency_seconds) = $event)),
                    modelModifiers: { number: true },
                    name: "pop_frequency_seconds",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('pop_frequency_seconds'),
                    help: _ctx.$t('pop_frequency_seconds_help'),
                    min: 0,
                    step: 60,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus",
                    suffix: ` ${_ctx.$t('sec')}`
                  }, null, 8, ["modelValue", "errors-map", "label", "help", "suffix"])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_FieldDropdown, {
                    modelValue: _ctx.endpoint.pop_targeting_by_countries,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.endpoint.pop_targeting_by_countries) = $event)),
                    modelModifiers: { number: true },
                    name: "pop_targeting_by_countries",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('targeting_type'),
                    options: _ctx.TARGETING_TYPES
                  }, null, 8, ["modelValue", "errors-map", "label", "options"]),
                  (_ctx.endpoint.pop_targeting_by_countries !== _ctx.TARGETING_TYPE_DISABLED)
                    ? (_openBlock(), _createBlock(_component_FieldListBox, {
                        key: 0,
                        modelValue: _ctx.endpoint.pop_countries_ids,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.endpoint.pop_countries_ids) = $event)),
                        loading: _ctx.countriesLoading,
                        options: _ctx.countries.data,
                        "option-value": "id",
                        "option-label": "compiled_name"
                      }, null, 8, ["modelValue", "loading", "options"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("h6", null, _toDisplayString(_ctx.$t('rotation')), 1),
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.allow_feeds,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.endpoint.allow_feeds) = $event)),
                    label: _ctx.$t('allow_feeds')
                  }, null, 8, ["modelValue", "label"])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.allow_campaigns,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.endpoint.allow_campaigns) = $event)),
                    label: _ctx.$t('allow_campaigns')
                  }, null, 8, ["modelValue", "label"])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.sensitive,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.endpoint.sensitive) = $event)),
                    label: _ctx.$t('sensitive')
                  }, null, 8, ["modelValue", "label"])
                ]),
                _createVNode(_component_FieldCheckbox, {
                  modelValue: _ctx.endpoint.hide_pseudosite_host_in_click_url,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.endpoint.hide_pseudosite_host_in_click_url) = $event)),
                  label: _ctx.$t('hide_pseudosite_host_in_click_url')
                }, null, 8, ["modelValue", "label"]),
                (_ctx.endpoint.traffic_category === _ctx.TRAFFIC_CATEGORY_MAINSTREAM)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createVNode(_component_FieldCheckbox, {
                        modelValue: _ctx.endpoint.only_mainstream_coverage,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.endpoint.only_mainstream_coverage) = $event)),
                        label: _ctx.$t('only_mainstream_coverage')
                      }, null, 8, ["modelValue", "label"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user.isSuperAdmin())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createVNode(_component_FieldCheckbox, {
                        modelValue: _ctx.endpoint.replace_feeds_responses,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.endpoint.replace_feeds_responses) = $event)),
                        label: _ctx.$t('replace_feeds_responses')
                      }, null, 8, ["modelValue", "label"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.show_ad_id,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.endpoint.show_ad_id) = $event)),
                    label: _ctx.$t('show_ad_id')
                  }, null, 8, ["modelValue", "label"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff() && _ctx.endpoint.allow_feeds)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _createElementVNode("h6", null, _toDisplayString(_ctx.$t('feeds')), 1),
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_FieldDropdownNext, {
                    modelValue: _ctx.endpoint.targeting_by_feeds_ids,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.endpoint.targeting_by_feeds_ids) = $event)),
                    modelModifiers: { number: true },
                    name: "targeting_by_feeds_ids",
                    label: _ctx.$t('targeting_type'),
                    options: _ctx.TARGETING_TYPES,
                    "option-label-translate": ""
                  }, null, 8, ["modelValue", "label", "options"]),
                  (_ctx.endpoint.targeting_by_feeds_ids !== _ctx.TARGETING_TYPE_DISABLED)
                    ? (_openBlock(), _createBlock(_component_FieldListBox, {
                        key: 0,
                        modelValue: _ctx.endpoint.feeds_ids,
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.endpoint.feeds_ids) = $event)),
                        name: "feeds_ids",
                        "errors-map": _ctx.endpointErrorsMap,
                        label: _ctx.$t('feeds'),
                        loading: _ctx.feedsLoading,
                        options: _ctx.feeds.data,
                        "option-value": "id",
                        "option-label": "compiled_name"
                      }, null, 8, ["modelValue", "errors-map", "label", "loading", "options"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff() && _ctx.endpoint.allow_campaigns)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("h6", null, _toDisplayString(_ctx.$t('advertisers')), 1),
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.endpoint.targeting_by_advertisers_ids,
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.endpoint.targeting_by_advertisers_ids) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_advertisers_ids",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"]),
                    (_ctx.endpoint.targeting_by_advertisers_ids !== _ctx.TARGETING_TYPE_DISABLED)
                      ? (_openBlock(), _createBlock(_component_FieldListBox, {
                          key: 0,
                          modelValue: _ctx.endpoint.advertisers_ids,
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.endpoint.advertisers_ids) = $event)),
                          name: "advertisers_ids",
                          "errors-map": _ctx.endpointErrorsMap,
                          label: _ctx.$t('advertisers'),
                          loading: _ctx.advertisersLoading,
                          options: _ctx.advertisers.data,
                          "option-value": "id",
                          "option-label": "compiled_name"
                        }, null, 8, ["modelValue", "errors-map", "label", "loading", "options"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("h6", null, _toDisplayString(_ctx.$t('campaigns')), 1),
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.endpoint.targeting_by_campaigns,
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.endpoint.targeting_by_campaigns) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_campaigns",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"]),
                    (_ctx.endpoint.targeting_by_campaigns !== _ctx.TARGETING_TYPE_DISABLED)
                      ? (_openBlock(), _createBlock(_component_FieldListBox, {
                          key: 0,
                          modelValue: _ctx.endpoint.campaigns_ids,
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.endpoint.campaigns_ids) = $event)),
                          name: "campaigns_ids",
                          "errors-map": _ctx.endpointErrorsMap,
                          label: _ctx.$t('campaigns'),
                          loading: _ctx.campaignsLoading,
                          options: _ctx.campaigns.data,
                          "option-value": "id",
                          "option-label": "compiled_name"
                        }, null, 8, ["modelValue", "errors-map", "label", "loading", "options"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff() || _ctx.endpoint.click_host)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_FieldText, {
                    modelValue: _ctx.endpoint.click_host,
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.endpoint.click_host) = $event)),
                    modelModifiers: { trim: true },
                    name: "click_host",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('custom_click_host'),
                    disabled: _ctx.user.isAffiliate()
                  }, null, 8, ["modelValue", "errors-map", "label", "disabled"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff() || _ctx.user.show_bounces)
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createVNode(_component_FieldTextarea, {
                    modelValue: _ctx.endpoint.passback_url,
                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.endpoint.passback_url) = $event)),
                    modelModifiers: { trim: true },
                    name: "passback_url",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: "Passback URL",
                    rows: 2
                  }, null, 8, ["modelValue", "errors-map"]),
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('available_macros')) + ":", 1),
                    _hoisted_56
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  (_ctx.user.isStaff())
                    ? (_openBlock(), _createBlock(_component_FieldCheckbox, {
                        key: 0,
                        modelValue: _ctx.endpoint.passback_forbidden_traffic,
                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.endpoint.passback_forbidden_traffic) = $event)),
                        label: _ctx.$t('passback_forbidden_traffic')
                      }, null, 8, ["modelValue", "label"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.endpoint.status,
                "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.endpoint.status) = $event)),
                modelModifiers: { number: true },
                name: "status",
                "errors-map": _ctx.endpointErrorsMap,
                label: _ctx.$t('status'),
                disabled: _ctx.user.isAffiliate(),
                options: _ctx.ENDPOINT_STATUSES
              }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options"])
            ])
          ]),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                _createVNode(_component_FieldTextarea, {
                  modelValue: _ctx.endpoint.comment,
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.endpoint.comment) = $event)),
                  modelModifiers: { trim: true },
                  name: "comment",
                  "errors-map": _ctx.endpointErrorsMap,
                  label: _ctx.$t('comment')
                }, null, 8, ["modelValue", "errors-map", "label"])
              ]))
            : _createCommentVNode("", true),
          (!!_ctx.endpoint.id && _ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                _createElementVNode("h6", null, _toDisplayString(_ctx.$t('declined_subids')), 1),
                _createVNode(_component_PrimeVueButton, {
                  class: "p-button-secondary w-full",
                  label: _ctx.$t('show'),
                  loading: _ctx.declinedSubidsLoading,
                  onClick: _ctx.getDeclinedSubids
                }, null, 8, ["label", "loading", "onClick"]),
                (_ctx.showDeclinedSubids)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      (_ctx.declinedSubids.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _createVNode(_component_FieldDropdown, {
                              modelValue: _ctx.declinedSubidsAsStringSeparator,
                              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.declinedSubidsAsStringSeparator) = $event)),
                              label: _ctx.$t('separator'),
                              options: _ctx.declinedSubidsAsStringSeparators
                            }, null, 8, ["modelValue", "label", "options"]),
                            _createVNode(_component_FieldTextarea, {
                              "model-value": _ctx.declinedSubidsAsString,
                              help: `${_ctx.declinedSubids.length} ${_ctx.$t('subids').toLowerCase()}`,
                              disabled: ""
                            }, null, 8, ["model-value", "help"])
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('nothing')), 1)
                          ], 64))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!!_ctx.endpoint.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createVNode(_component_FieldText, {
                    modelValue: _ctx.endpoint.created_at,
                    label: _ctx.$t('created_at'),
                    disabled: ""
                  }, null, 8, ["modelValue", "label"]),
                  _createVNode(_component_FieldText, {
                    modelValue: _ctx.endpoint.updated_at,
                    label: _ctx.$t('updated_at'),
                    disabled: ""
                  }, null, 8, ["modelValue", "label"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "entry", "entry-fetch-handler", "entry-store-handler", "entry-errors-map"]))
}